
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspo",
      function () {
        return require("private-next-pages/inspo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspo"])
      });
    }
  